import { DataTableMeta, DateColumn, Select } from '@otp/ui';
import { TFunction } from 'i18next';
import React from 'react';

import { WttpQuestionnaire, WttpSchedule } from 'src/graphql/generated/graphql';

export type QuestionnairesSchedule = {
  questionnaireId: string;
  scheduleId?: string;
};

export type OnScheduleChangeType = (
  data: Required<QuestionnairesSchedule>,
) => void;

export const getTableConfig = (
  wttpQuestionnaires: Pick<
    WttpQuestionnaire,
    'id' | 'name' | 'createdAt' | 'updatedAt'
  >[],
  {
    t,
    onScheduleChange,
    schedules,
    selectedQuestionnaireIds,
    value,
  }: {
    t: TFunction;
    onScheduleChange: OnScheduleChangeType;
    schedules: Pick<WttpSchedule, 'id' | 'name'>[];
    selectedQuestionnaireIds: string[];
    value?: QuestionnairesSchedule[];
  },
) => [
  {
    name: 'name',
    label: t('common.name'),
  },
  {
    name: 'updatedAt',
    label: t('common.updated-at'),
    options: {
      customBodyRender: (value: string, column: DataTableMeta) => {
        const wttpQuestionnaire = wttpQuestionnaires[column.rowIndex];
        return <DateColumn date={value || wttpQuestionnaire.createdAt} />;
      },
      isDesktopOnly: true,
    },
  },
  {
    name: 'schedule',
    label: t('common.schedule'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const wttpQuestionnaire = wttpQuestionnaires[column.rowIndex];
        const options = schedules.map((item) => ({
          value: item.id,
          name: item.name,
        }));

        const defaultSelectedScheduleId = value?.find(
          (item) => item.questionnaireId === wttpQuestionnaire.id,
        )?.scheduleId;

        return (
          <div className="w-28">
            <Select
              fullWidth={true}
              options={options}
              placeholder={t('common.schedule')}
              disabled={
                !selectedQuestionnaireIds.includes(wttpQuestionnaire.id)
              }
              defaultValue={defaultSelectedScheduleId}
              onChange={(e) =>
                onScheduleChange({
                  questionnaireId: wttpQuestionnaire.id,
                  scheduleId: e.target.value,
                })
              }
            />
          </div>
        );
      },
    },
  },
];
